export enum MarketingAnalyticsPage {
  OVERVIEW = "overview",
  AUDIENCE = "audience",
  BACK_IN_STOCK = "back-in-stock",
  PERFORMANCE = "performance",
}

export const MARKETING_ANALYTICS_TABS_URL_PARAM = "tab";
